/*
<yz-responsive-video>
  <video
    width="640"
    height="360"
    controls
    autoplay
    loop>
    <source
      src="../assets/videos/large.mp4"
      type="video/mp4"
      media="(min-width: 600px)"
    />
    <source
      src="../assets/videos/small.mp4"
      type="video/mp4"
    />
    <source
      src="landscape.webm"
      type="video/webm"
      media="(orientation: landscape)"
    />
    <source
      src="@root/assets/videos/movieclip.ogv"
      type="video/ogg"
    />
  </video>
</yz-responsive-video>

<video src="https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8"></video>

<video src="../assets/videos/sintel.webm" width="320" height="138"></video>

<audio controls>
  <source
    src="/sandbox/video-media/roar.mp3"
    media="(max-width: 599px)"
  />
  <source src="/sandbox/video-media/cluck.mp3" />
</audio>
*/

export class ResponsiveVideo extends HTMLElement {
  constructor() {
    super();
    this.listenedMedia = [];
    this.reloadQueued = false;
  }
  connectedCallback() {
    this.video = this.querySelector("video");
    this.bindMediaListeners();
  }
  disconnectedCallback() {
    this.unbindMediaListeners();
  }
  bindMediaListeners() {
    this.querySelectorAll("source").forEach((source) => {
      if (source.media) {
        const mqListener = () => {
          if (
            source.media === this.video.currentSrc ||
            (!this.previousSiblingIsPlaying(source, this.video.currentSrc) &&
              !this.reloadQueued)
          ) {
            this.reloadVideo();
          }
        };
        this.listenedMedia.push({ media: source.media, handler: mqListener });
        window.matchMedia(source.media).addEventListener("change", mqListener);
      }
    });
  }
  unbindMediaListeners() {
    this.listenedMedia.forEach((listener) => {
      window
        .matchMedia(listener.media)
        .removeEventListener("change", listener.handler);
    });
  }
  previousSiblingIsPlaying(elem, src) {
    const prevSibling = elem;
    while (elem.previousElementSibling) {
      if (prevSibling.src === src) {
        return true;
      }
    }
    return false;
  }
  reloadVideo() {
    this.reloadQueued = true;
    const currentTime = this.video.currentTime;
    const playState = this.video.playState;
    this.video.load();
    const videoLoaded = () => {
      this.video.playState = playState;
      this.video.currentTime = currentTime.toString();
      this.reloadQueued = false;
      this.video.removeEventListener("loadeddata", videoLoaded);
    };
    this.video.addEventListener("loadeddata", videoLoaded);
  }
}

export default ResponsiveVideo;
